/**
 * Auth Prompt Service
 * 
 * Handles authentication prompts from the API (e.g., when user asks about memory)
 * Opens auth modal when needed.
 */

/**
 * Open authentication modal
 * This can be called from anywhere in the app
 */
export function openAuthModal(reason?: string): void {
  // Emit event that paper-mode.html or other components can listen to
  const event = new CustomEvent('open-auth-modal', {
    detail: { reason },
  });
  window.dispatchEvent(event);
  
  // Also try to call showAuthModal if it exists (for paper-mode.html)
  if (typeof (window as any).showAuthModal === 'function') {
    (window as any).showAuthModal();
  }
}

/**
 * Listen for auth prompts from streaming API responses
 */
export function initializeAuthPromptListener(): void {
  // Listen for openAuth actions in streaming responses
  // This would be called from wherever SSE events are handled
  // For now, we'll provide a helper that can be called when processing SSE events
  
  // Also listen for the custom event (in case something else triggers it)
  window.addEventListener('open-auth-modal', ((e: CustomEvent) => {
    const { reason } = e.detail || {};
    console.log('[Auth Prompt] Opening auth modal, reason:', reason);
    openAuthModal(reason);
  }) as EventListener);
}

/**
 * Check if an SSE event contains an openAuth action
 */
export function handleStreamingAction(action: any): void {
  if (action?.type === 'openAuth') {
    openAuthModal(action.reason);
  }
}

